<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Dispatch Order</h2>
        <h2>Order Date : {{ formatDate(order.createdAt) }}</h2>
        <h2>Order ID : {{ order.id }}</h2>
        <h2>Order Amount : {{ order.totalAmount }}</h2>
        <h2>Order Status : {{ order.status }}</h2>
        <h2>Client Name : {{ order.client.name }}</h2>
        <h2>Client Phone : {{ order.client.phone }}</h2>
        <h2>Client Address : {{ order.client.address }}</h2>
  
        <form @submit.prevent="dispatchOrder" class="mt-4">
           <h2>Select a Staff for Delivery</h2>
          <select v-model="localOrder.staff" class="w-full p-2 border rounded-lg mb-4" required>
            <option disabled value="">Select Delivery Staff</option>
            <option v-for="staff in staffs" :key="staff.id" :value="staff">{{ staff.name }}</option>
          </select>
          <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Dispatch Order</button>
        </form>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
import { mapActions, mapState } from 'vuex';

  export default {
    props: {
      order: {
    
      },
    },
    async mounted(){
        await this.fetchStaffs();
    },
    data() {
      return {
        localOrder: { ...this.order , staff : null }, // Create a local copy of the staff prop
      };
    },
    computed : {
        ...mapState('staffs',
        {
            staffs: state => state.staffs
        })
    },
    methods: {
        ...mapActions('orders', {editOrder : 'editOrder'}),
        ...mapActions('deliveries',{
            addDelivery : 'addDelivery'
        }),
      ...mapActions('staffs',{
        fetchStaffs : 'fetchStaffs'
      }),
      ...mapActions(),
      async dispatchOrder(){
        const delivery = {
            order : this.localOrder.id,
            client : this.localOrder.client.id,
            staff : this.localOrder.staff.id
        }
        this.localOrder.status = 'DELIVERING';
        this.localOrder.staff = this.localOrder.staff.id; // Store only the staff ID
        await this.addDelivery(delivery);
        await this.editOrder(this.localOrder);
        this.$emit('closeModal');
      },
      submitOrder() {
        this.$emit('editOrder', this.localOrder);
        this.closeModal();
      },
      closeModal() {
        this.$emit('closeModal');
      },
      formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    },
  };
  </script>
  